import * as React from 'react'
import styled from 'styled-components'
import Amount from 'theme/atoms/Amount'
import { CartItem } from 'hooks/account/types'
import theme from 'theme'
import TrashIcon from 'assets/trash.svg'
import useTranslations from 'hooks/useTranslations'
import Share from 'theme/molecules/Share'
import getProductLink from 'utils/getProductLink'
import Spinner from 'theme/atoms/Spinner'
import useCartDeleteContex from 'hooks/account/useAccount/cart/useCartContext'

type Props = {
  item: CartItem
  updateItem: (amount: number) => void
}

export function AmountChanger(props: Props) {
  const t = useTranslations<'molecules-account-CartItem'>()
  const $amountChanger = React.useRef<HTMLDivElement>(null)
  const [isUpdating, setIsUpdating] = React.useState(false)
  const cartDeleteContex = useCartDeleteContex()
  const { deletedItems, deletedItem, cartUpdating } = cartDeleteContex

  const handleDelete = () => {
    setIsUpdating(true)
    cartDeleteContex.deleteItem(props.item.cartItemId)
  }

  React.useEffect(() => {
    if (cartUpdating) {
      setIsUpdating(
        deletedItems.includes(props.item.cartItemId) ||
          deletedItem === props.item.cartItemId
      )
    }
  }, [cartUpdating])
  return (
    <Wrapper className="AmountChanger">
      <Amount
        ref={$amountChanger}
        minValue={1}
        maxValue={9999}
        value={props.item.quantity}
        setValue={(val) => val !== props.item.quantity && props.updateItem(val)}
        data-cy-handle-increase={'amount-increase'}
        data-cy-handle-decrease={'amount-decrease'}
        data-cy-handle-amount={'amount-input'}
        decrease_button_a11y_title={t.asText(
          $amountChanger,
          'molecules_account_cartitem_amountchanger_a11y_decrease_button'
        )}
        amount_input_a11y_title={t.asText(
          $amountChanger,
          'molecules_account_cartitem_amountchanger_a11y_amount_input'
        )}
        increase_button_a11y_title={t.asText(
          $amountChanger,
          'molecules_account_cartitem_amountchanger_a11y_increase_button'
        )}
      />
      <div className="cart-item-actions">
        <Share
          productName={props.item.title}
          buttonType="symbol_and_text"
          linkToShare={getProductLink(props.item)}
          internalLink
        ></Share>
        {isUpdating && (
          <Spinner
            className="spinner"
            data-cy-state="display-deleting-spinner"
            size="small"
          />
        )}
        {!isUpdating && (
          <div
            className="delete"
            data-cy-handle="delete-btn"
            data-cy-state="display-delete-button"
            onClick={handleDelete}
          >
            <TrashIcon />
            {t('delete')}
          </div>
        )}
      </div>
    </Wrapper>
  )
}
export default AmountChanger

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${theme.spacing('m')};

  > .cart-item-actions {
    display: flex;
    align-items: center;
    gap: ${theme.spacing('m')};
    > .delete {
      ${theme.ty('r-xs', null, 'r-s')}
      text-decoration: underline;
      color: ${theme.colors.shade.b3};
      display: flex;
      align-items: center;
      cursor: pointer;
      > svg {
        width: 12px;
        height: 13px;
        margin-right: 8px;
      }
    }

    > .Share {
      > .share_button {
        > .share_icon {
          height: 18px;
        }

        > .share_button_label {
          ${theme.ty('r-xs', null, 'r-s')}
          text-decoration: underline;
          color: ${theme.colors.shade.b3};

          > .normal {
            font-weight: normal;
          }
        }
      }
    }
  }
`
